import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/layout/HeaderX';
import Navigation from './components/layout/Navigation';

import Home from './components/HomeX';
import Orders from './components/Orders';
import Certificates from './components/Certificates';
import Mailbox from './components/Mailbox';
import Filemanager from './components/Filemanager';
import Scanner from './components/Scanner';
import Login from './components/auth/Login';
import Logout from './components/auth/Logout';
import PrivateRoute from './components/auth/PrivateRoute';

function App() {
  const location = useLocation();
  const [title, setTitle] = useState("");

  useEffect(() => {
    // Mappa delle route con i titoli corrispondenti
    const routeTitles = {
      '/': 'Home',
      '/orders': 'Orders',
      '/certificates': 'Certificates',
      '/mailbox': 'Mailbox',
      '/filemanager': 'File Manager',
      '/scanner': 'Scanner',
      '/login': 'Login',
    };

    // Aggiorna il titolo della pagina
    setTitle(document.title = routeTitles[location.pathname] || 'Default Title');
  }, [location]);

  // Verifica se l'utente si trova sulla pagina di login
  const isLoginPage = location.pathname === '/login';
  
  return (
    <>
    {isLoginPage ? (
        // Template per la pagina di login
        <div className="login-container">
          <Routes>
            <Route path="/login" element={<Login />} />
          </Routes>
        </div>
      ) : (
        <>
        {/* [ Pre-loader ] start */}
        <div className="loader-bg">
          <div className="loader-track">
            <div className="loader-fill" />
          </div>
        </div>
        {/* [ Pre-loader ] End */}
        {/* [ navigation menu ] start */}
        <Navigation></Navigation>
        {/* [ navigation menu ] end */}
        {/* [ Header ] start */}
        <Header></Header>
        {/* [ Header ] end */}
        {/* [ status bar ] start */}
        <div id="status" />
        {/* [ status bar ] end */}
        {/* [ Main Content ] start */}
        <div className="pcoded-main-container">
          <div className="pcoded-content">
            {/* [ breadcrumb ] start */}
            {/* [ breadcrumb ] end */}
            {/* [ Page content ] start */}
            <div className="row HOME">
                <div className="col-12">
                    <Routes>
                      <Route path="/login" element={<Login />} />
                      <Route path="/logout" element={<Logout />} />
                      <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
                      <Route path="/orders" element={<PrivateRoute><Orders /></PrivateRoute>} />
                      <Route path="/certificates" element={<PrivateRoute><Certificates /></PrivateRoute>} />
                      <Route path="/mailbox" element={<PrivateRoute><Mailbox /></PrivateRoute>} />
                      <Route path="/filemanager" element={<PrivateRoute><Filemanager /></PrivateRoute>} />
                      <Route path="/scanner" element={<PrivateRoute><Scanner /></PrivateRoute>} />
                    </Routes> 
                </div>
            </div>
            
            {/* [ Page content ] end */}
          </div>
        </div>
        {/* [ Main Content ] end */}
      </>
      )}
      </>
  );
}

export default App;
